module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"43ebb48825a76fcb3c4dc90a41b53186"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
